import { createGlobalStyle } from "styled-components";
const GlobalStyle = createGlobalStyle`
*{
    padding:0;
    margin:0;
    box-sizing: border-box;
}
html{
    @media (max-width : 1700px){
        font-size: 75%;
    }
    
}
body{
    background:#1b1b1b;
    font-family:"Poppins",sans-serif;
    overflow-x:hidden;
}
button{
    font-weight:bold;
    font-size:1.1rem;
    cursor:pointer;
    padding:1rem 2rem;
    border: 3px solid #23d997;
    background: transparent;
    color:white;
    transition:0.3s all ease;
    &:hover{
        background:#23d997;
        color:white;
    }
}
h2{
    font-weight:lighter;
    font-size:3rem;
}
h3{
    color:white;
    padding: 1rem
}
h4{
    font-weight:bold;
    font-size:2rem;
}
span{ font-weight:bold;
    color:#23d997;}
a{
    font-size:1.1rem;
}
p{
    padding: 3rem 0rem;
    color:#ccc;
    font-size:1.4rem;
    line-height:150%;
}
`;
export default GlobalStyle;
